/**
 * 支持base64字符解码为中文
 *
 * @category Logic
 *
 * @public
 *
 * @param value - 需要进行解码的值
 *
 * @returns 解码后的值
 */
export function atobUnicode(value) {
    return decodeURIComponent(atob(value)
        .split("")
        .map(function (c) { return "%" + ("00" + c.charCodeAt(0).toString(16)).slice(-2); })
        .join(""));
}
//# sourceMappingURL=atobUnicode.js.map